import classNames from "classnames";

import type { IconName } from "@similarweb/icons";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";

import { StyledIcon, StyledInnerWrap, StyledNumberOfSignals, StyledSignalTypeWrap, StyledText } from "./styles";

type SignalTypeProps = {
    className?: string;
    iconName: IconName;
    isActive?: boolean;
    numberOfSignals?: number;
    signalType: SignalType;
    onClick?(signalType: SignalType): void;
};

const SignalTypeView = (props: SignalTypeProps) => {
    const { className, iconName, isActive = false, numberOfSignals = 0, signalType, onClick } = props;

    function handleClick() {
        onClick?.(signalType);
    }

    return (
        <StyledSignalTypeWrap
            className={classNames(className, { "--active": isActive })}
            data-automation="signal-type"
            data-automation-type={signalType}
            onClick={handleClick}
        >
            <StyledInnerWrap>
                <StyledIcon
                    iconName={iconName}
                    size="xs"
                />

                <I18n
                    data-automation="type-text"
                    element={StyledText}
                    translatable={{ key: `si.signals.type.${signalType}.text` }}
                />

                <StyledNumberOfSignals data-automation="number-of-signals-text">
                    {numberOfSignals}
                </StyledNumberOfSignals>
            </StyledInnerWrap>
        </StyledSignalTypeWrap>
    );
};

export default SignalTypeView;
